module.exports = {
  integrations: 
    {
      hubspot: 
      {
        type: "HubSpot",
        title: "Welcome to Paperflite’s integration with HubSpot! Elevate your sales game with seamless content sharing and detailed analytics.",
        sections: [
          {
            id: "about",
            title: "About",
            sub_sections : [
              {
                header: "What you get out of this integration:",
                sub_header: "",
                content: [
                  'Share all your sales and marketing content via HubSpot using our plugin.',
                  'Sync all your HubSpot contacts and leads with Paperflite within minutes.',
                  'Learn what your prospects have been viewing, downloading and re-sharing, so you can tailor your follow-ups accordingly.',
                  'Sync events to track preferred prospect engagement events like views, downloads, shares for tailored follow-ups.',
                  'Capture every interaction, from page-level views to time spent on videos.',
                  'Track specific visitor activities by creating <a href="https://support.paperflite.com/en/articles/10398082-integrating-hubspot-x-paperflite-custom-events" target="_blank">custom behavioral events.</a>',
                  'Effortlessly map deals from HubSpot to shares made to associated contacts in Paperflite.',
                  'Automatically capture leads gained through gated shares from Paperflite directly into HubSpot.',
                  'Leverage predictive analytics to forecast open deals and receive tailored recommendations, guiding you towards winning deals if you have Paperflite’s Deal Insights module enabled.'
                ]
              }
            ]
          },
          {
            id: "configuration",
            title: "Configuration",
            sub_sections: [
              {
                header: "Get started: Learn how to integrate",
                sub_header: "",
                content: [
                  "Ensure you're logged in to the HubSpot account you wish to integrate.",
                  "Authenticate the HubSpot account: <br/> &nbsp; - Choose the HubSpot account you want to integrate. <br/> &nbsp; - Review permissions and connect the app.",
                  'Make sure you have downloaded and logged into the <a href="https://support.paperflite.com/en/articles/10398099-chrome-extension" target="_blank">Chrome extension.</a>',
                  "Configure settings according to your preferences.",
                  "Your integration is now ready to go!"
                ],
                note: "<b> Note: </b> The integration with HubSpot is an admin level integration. This means only admins would have the access to first activate, and make changes at an account level. Once an Admin has configured the integration for the Account, the rest of the users in the company will have the integration activated and be able to override the configuration settings for themselves."
              }
            ]
          },
          {
            id: "demo_video",
            title: "Demo Video",
            sub_sections: [
              {
                header: "Watch this video to see how the integration works:",
                sub_header: "",
                video: "https://www.youtube.com/embed/xnN6NHp_SP0?rel=0&loop=1&playlist=xnN6NHp_SP0"
              }
            ]
          },
          {
            id: "technical_requirements",
            title: "Technical Requirements",
            sub_sections: [
              {
                header: "For this integration to be successful, you will require:",
                sub_header: "",
                content: [
                "<b>Paperflite Chrome Extension:</b> Make sure to have the latest chrome extension downloaded and stay logged in to your Paperflite account.",
                "<b>HubSpot Account: </b> Make sure to have an active HubSpot account logged in.",
              ]
              }, 
              {
                header: "Necessary permissions",
                sub_header: "By activating this integration, Paperflite will  have access to your HubSpot account. This means Paperflite will have access to:",
                content: [
                  "<b>Manage and View your CRM Data: </b> Access to properties and other details about deals, contacts and companies.",
                  "<b>Basic OAuth functionality: </b> The basic scope required for OAuth.",
                  "<b>Forms: </b> This includes access to the Forms API."
                ]
              }
            ]
          }
        ],
        support_articles: {
          title: "Support Articles:",
          content: [
            {
              title: "Paperflite X HubSpot",
              url: "https://support.paperflite.com/en/articles/10398109-integrating-hubspot-in-paperflite"
            },
            {
              title: "Custom Events",
              url: "https://support.paperflite.com/en/articles/10398082-integrating-hubspot-x-paperflite-custom-events"
            },
          ]
        }
      },

    gmail: 
      {
        type: "Gmail",
        title: "Welcome to Paperflite’s integration with Gmail! Elevate your outreach with the Paperflite x Gmail integration!",
        sections: [
          {
            id: "about",
            title: "About",
            sub_sections : [
              { 
                header: "What you get out of this integration:",
                content: [
                  "<b> Streamlined Communication:</b> You can send mails directly from Paperflite with attached content with each mail appearing as if it was sent directly from your Gmail account.",
                  '<b>Content Accessibility: </b> Access and share all your Paperflite content directly within Gmail using our <a href="https://support.paperflite.com/en/articles/10391178-gmail-add-in" target="_blank">Gmail add-in</a> eliminating the need to switch between platforms.',
              ]
              }
            ]
          },
          {
            id: "configuration",
            title: "Configuration",
            sub_sections: [
              {
                header: "Get started: Learn how to integrate",
                content: [
                  "Ensure you're logged in to the Gmail account you wish to integrate.",
                  "Authenticate the Gmail account in the Paperflite Integration page."
                ]
              }
            ]
          },
          {
            id: "demo_video",
            title: "Demo Video",
            sub_sections: [
              {
                header: "Watch this video to see how the integration works:",
                video: "https://www.youtube.com/embed/r0alxDD8a7M?si=SUlEYke3oRxenzhv"
              }
            ]
          },
          {
            id: "technical_requirements",
            title: "Technical Requirements",
            sub_sections: [
              {
                header: "For this integration to be successful, you will require:",
                content: [
                "<b> Gmail Account:</b> Make sure to have an active Gmail account logged in.",
              ]
              }, 
              {
                header: "Necessary permissions",
                sub_header: "By activating this integration, Paperflite will  have access to your Gmail account. This means Paperflite will have access to:",
                content: [
                  "Send emails on your behalf"
            ]}
            ]
          }
        ],
        support_articles: {
          title: "Support Articles:",
          content: [
            {
              title: "Paperflite X Gmail",
              url: "https://support.paperflite.com/en/articles/10398110-integrate-with-gmail"
            },
            {
              title: "Gmail add-in",
              url: "https://support.paperflite.com/en/articles/10391178-gmail-add-in"
            }
          ]
        }
      },

    slack: 
      {
        type: "Slack",
        title: "Welcome to Paperflite’s integration with Slack! Staying updated on prospect engagement has never been easier.",
        sections: [
          {
            id: "about",
            title: "About",
            sub_sections : [
              { 
                header: "What you get out of this integration:",
                content: [
                  "<b> Instant Visibility:</b> Receive instant notifications in Slack whenever your prospects engage with your shared content, including views, downloads, and resharing activities. Stay in the loop and act promptly on prospect interest.",
              ]
              }
            ]
          },
          {
            id: "configuration",
            title: "Configuration",
            sub_sections: [
              {
                header: "Get started: Learn how to integrate",
                content: [
                  "Authenticate the Slack account you wish to integrate with.",
                  "Add the ‘Paperflite’s interaction updates’ app in Slack ",
                  "Your integration is now ready to go!"
                ]
              }
            ]
          },
          {
            id: "demo_video",
            title: "Demo Video",
            sub_sections: [
              {
                header: "Watch this video to see how the integration works:",
                video: "https://www.youtube.com/embed/vPBCLEUHq4o?si=NBlzy8y_CEMgHPJf"
              }
            ]
          }, 
          { 
            id: "technical_requirements",
            title: "Technical Requirements",
            sub_sections: [
              {
                header: "For this integration to be successful, you will require:",
                content: [
                "Make sure to have push notifications turned on for triggers you would like to be notified about in the notifications center in Paperflite.",
                "Make sure to have an active Slack account logged in.",
              ]
              }, 
              {
                header: "Necessary permissions",
                sub_header: "By activating this integration, Paperflite will  have access to your Slack  account. This means Paperflite will have access to:",
                content: [
                  "View content and info about you",
                  "View content and info about your channels and conversation",
                  "Send messages on your behalf"
            ]}
            ]
          }
        ],
        support_articles: {
          title: "Support Articles:",
          content: [
            {
              title: "Paperflite X Slack",
              url: "https://support.paperflite.com/en/articles/10398088-slack-integration"
            },
          ]
        }
      },

    pipedrive: 
      {
        type: "Pipedrive",
        title: "Welcome to Paperflite’s integration with Pipedrive! Elevate your sales game with seamless content sharing and detailed analytics.",
        sections: [
          {
            id: "about",
            title: "About",
            sub_sections : [
              {
                header: "What you get out of this integration:",
                sub_header: "",
                content: [
                  'Share all your sales and marketing content via Pipedrive using our plugin from within your email, contacts, opportunities and templates.',
                  'Sync all your Pipedrive contacts and leads with Paperflite within minutes.',
                  'Automatically capture leads gained through gated shares from Paperflite directly into Pipedrive.',
                  'Learn what your prospects have been viewing, downloading and re-sharing, so you can tailor your follow-ups accordingly',
                  'Sync events to track preferred prospect engagement events like views, downloads, shares for tailored follow-ups.',
                  'Capture every interaction, from page-level views to time spent on videos',
                  'Effortlessly map deals from Pipedrive to shares made to associated contacts in Paperflite.',
                  'Leverage predictive analytics to forecast open deals and receive tailored recommendations, guiding you towards winning deals if you have Paperflite’s Deal Insights module enabled.'
                ]
              }
            ]
          },
          {
            id: "configuration",
            title: "Configuration",
            sub_sections: [
              {
                header: "Get started: Learn how to integrate",
                sub_header: "",
                content: [
                  "Ensure you're logged in to the Pipedrive account you wish to integrate.",
                  "Authenticate the Pipedrive account: <br/> &nbsp; - Choose the Pipedrive account you want to integrate. <br/> &nbsp; - Review permissions and connect the app.",
                  'Make sure you have downloaded and logged into the <a href="https://support.paperflite.com/en/articles/10398099-chrome-extension" target="_blank">Chrome extension.</a>',
                  "Configure settings according to your preferences.",
                  "Your integration is now ready to go!"
                ],
              }
            ]
          },
          {
            id: "demo_video",
            title: "Demo Video",
            sub_sections: [
              {
                header: "Watch this video to see how the integration works:",
                sub_header: "",
                video: "https://www.youtube.com/embed/NmmNiWsIDxE?si=_4LxA6e310Z06PrC"
              }
            ]
          },
          {
            id: "technical_requirements",
            title: "Technical Requirements",
            sub_sections: [
              {
                header: "For this integration to be successful, you will require:",
                sub_header: "",
                content: [
                "<b>Paperflite Chrome Extension:</b> Make sure to have the latest chrome extension downloaded and stay logged in to your Paperflite account.",
                "<b>Pipedrive Account: </b> Make sure to have an active Pipedrive account logged in.",
              ]
              }, 
              {
                header: "Necessary permissions",
                sub_header: "By activating this integration, Paperflite will  have access to your Pipedrive account. This means Paperflite will have access to:",
                content: [
                  'Basic information like settings of authorized users and currencies of an account.',
                  'Activities and read access to activity fields and types.',
                  'Contacts and read access to contact fields.',
                  'Read user data - permissions, roles and followers.',
                  'Search for data across deals, contacts and organizations',
                  'Perform admin activities like create, edit and delete pipelines and stages, user permissions, etc.'
                ]
              }
            ]
          }
        ],
        support_articles: {
          title: "Support Articles:",
          content: [
            {
              title: "Pipedrive Integration",
              url: "https://support.paperflite.com/en/articles/10398116-pipedrive-integration"
            },
          ]
        }
      },
    outlook:
      {
        type: "Outlook",
        title: "Elevate your outreach with the Paperflite x Outlook integration!",
        sections: [
          {
            id: "about",
            title: "About",
            sub_sections : [
              {
                header: "What you get out of this integration:",
                content: [
                  "<b>Streamlined Communication: </b> You can send mails directly from Paperflite with attached content with each mail appearing as if it was sent directly from your Outlook account.",
                  '<b>Content Accessibility: </b> Access and share all your Paperflite content directly within Outlook using our <a href="https://support.paperflite.com/en/articles/10391109-outlook-add-in" target="_blank">Outlook add-in</a> eliminating the need to switch between platforms.'
                ]
              }
            ]
          },
          {
            id: "configuration",
            title: "Configuration",
            sub_sections: [
              {
                header: "Get started: Learn how to integrate",
                content: [
                  "Ensure you're logged in to the Outlook account you wish to integrate.",
                  "Authenticate the Outlook account in the Paperflite Integration page.",
                ]
              }
            ]
          },
          {
            id: "demo_video",
            title: "Demo Video",
            sub_sections: [
              {
                header: "Watch this video to see how the integration works:",
                video: "https://www.youtube.com/embed/-F_hX7eDlfA?si=DHht_80ev1Ph2Rux"
              }
            ]
          },
          {
            id: "technical_requirements",
            title: "Technical Requirements",
            sub_sections: [
              {
                header: "For this integration to be successful, you will require:",
                content: [
                  "<b>Outlook Account:</b> Make sure to have an active Outlook account logged in."
              ]
              },
              {
                header: "Necessary permissions",
                sub_header: "By activating this integration, Paperflite will  have access to your Outlook account. This means Paperflite will have access to:",
                content: [
                  "Data you have given Paperflite access to",
                  "Send mails on your behalf",
                  "Read your profile"
                ]
              }
            ]
          }
        ],
        support_articles: {
          title: "Support Articles:",
          content: [
            {
              title: "Paperflite X Outlook",
              url: "https://support.paperflite.com/en/articles/10398113-integrate-with-outlook"
            },
            {
              title: "Outlook add-in",
              url: "https://support.paperflite.com/en/articles/10391109-outlook-add-in"
            }
          ]
        }
      },
    salesforce: 
      {
        type: "Salesforce",
        title: "Welcome to Paperflite’s integration with Salesforce! Elevate your sales game with seamless content sharing and detailed analytics. ",
        sections: [
          {
            id: "about",
            title: "About",
            sub_sections : [
              {
                header: "What you get out of this integration:",
                sub_header: "",
                content: [
                  'Share all your sales and marketing content via Salesforce using our plugin',
                  'Sync all your Salesforce contacts, leads and opportunities with Paperflite within minutes.',
                  'Learn what your prospects have been viewing, downloading and re-sharing, so you can tailor your follow-ups accordingly',
                  'Sync events to track preferred prospect engagement events like views, downloads, shares for tailored follow-ups.',
                  'Automatically capture leads gained through gated shares from Paperflite directly into Salesforce.',
                  'Capture every interaction, from page-level views to time spent on videos.',
                  'Effortlessly map deals from Salesforce to shares made to associated contacts in Paperflite.',
                  'Tag content in Paperflite using fields from Salesforce, enabling personalized content recommendations at an opportunity level using AI-powered algorithms.',
                  'Eliminate the need to switch platforms with access to Paperflite lite app instance within the Salesforce instance.',
                  'Gain insights into share history associated with your contacts along with analytics.',
                  'Keep a track of all shares associated with a particular opportunity.',
                  'Leverage predictive analytics to forecast open deals and receive tailored recommendations, guiding you towards winning deals if you have Paperflite’s Deal Insights module enabled.'
                ]
              }
            ]
          },
          {
            id: "configuration",
            title: "Configuration",
            sub_sections: [
              {
                header: "Get started: Learn how to integrate",
                sub_header: "",
                content: [
                  "Ensure you're logged in to the Salesforce account you wish to integrate.",
                  "Authenticate the Salesforce account",
                  'Make sure you have downloaded and logged into the <a href="https://support.paperflite.com/en/articles/10398099-chrome-extension" target="_blank">Chrome extension.</a>',
                  "Configure settings according to your preferences.",
                  "Your integration is now ready to go!"
                ],
                note: "<b> Note: </b> The integration with Salesforce is an admin level integration. This means only admins would have the access to first activate, and make changes at an account level. Once an Admin has configured the integration for the Account, the rest of the users in the company will have the integration activated and be able to override the configuration settings for themselves."
              }
            ]
          },
          {
            id: "demo_video",
            title: "Demo Video",
            sub_sections: [
              {
                header: "Watch this video to see how the integration works:",
                sub_header: "",
                video: "https://www.youtube.com/embed/LmkUH-IvZtQ?si=xNO2tXGNO6AoGLJT" 
              }
            ]
          },
          {
            id: "technical_requirements",
            title: "Technical Requirements",
            sub_sections: [
              {
                header: "For this integration to be successful, you will require:",
                sub_header: "",
                content: [
                "<b>Paperflite Chrome Extension:</b> Make sure to have the latest chrome extension downloaded and stay logged in to your Paperflite account.",
                "<b>Salesforce Account: </b> Make sure to have an active Salesforce account logged in.",
              ]
              }, 
              {
                header: "Necessary permissions",
                sub_header: "By activating this integration, Paperflite will  have access to your Salesforce account. This means Paperflite will have access to:",
                content: [
                  "<b>Manage and View your CRM Data: </b> Access to properties and other details about deals, contacts and companies.",
                  "<b>Basic OAuth functionality: </b> The basic scope required for OAuth.",
                ]
              }
            ]
          }
        ],
        support_articles: {
          title: "Support Articles:",
          content: [
            {
              title: "Paperflite X Salesforce",
              url: "https://support.paperflite.com/en/articles/10398119-salesforce-integration"
            },
            {
              title: "Content recommendations",
              url: "https://support.paperflite.com/en/articles/10410143-how-do-i-set-up-recommended-content-on-my-salesforce-account"
            },
            {
              title: "Auto Mapping of Deals",
              url: "https://support.paperflite.com/en/articles/10398922-auto-mapping-of-deals-salesforce"
            }
          ]
        }
      },
    outreach:
      {
        type: "Outreach",
          title: "Welcome to Paperflite’s integration with Outreach! Elevate your sales game with seamless content sharing and detailed analytics.",
          sections: [
            {
              id: "about",
              title: "About",
              sub_sections : [
                {
                  header: "What you get out of this integration:",
                  sub_header: "",
                  content: [
                    'Share all your sales and marketing content via Outreach using our plugin within prospects, templates, sequences and snippets.',
                    'Sync all your Outreach prospects with Paperflite within minutes. ',
                    'Learn what your prospects have been viewing and re-sharing, so you can tailor your follow-ups accordingly',
                    'Sync events to track preferred prospect engagement events like views and shares for tailored follow-ups',
                    'Capture every interaction, from page-level views to time spent on videos.'
                  ]
                }
              ]
            },
            {
              id: "configuration",
              title: "Configuration",
              sub_sections: [
                {
                  header: "Get started: Learn how to integrate",
                  sub_header: "",
                  content: [
                    "Ensure you're logged in to the Outreach account you wish to integrate.",
                    "Activate the Outreach integration in Paperflite and authenticate your Outreach account.",
                    'Make sure you have downloaded and logged into the <a href="https://support.paperflite.com/en/articles/10398099-chrome-extension" target="_blank">Chrome extension.</a>',
                    "Configure settings according to your preferences.",
                    "Your integration is now ready to go!"
                  ],
                }
              ]
            },
            {
              id: "demo_video",
              title: "Demo Video",
              sub_sections: [
                {
                  header: "Watch this video to see how the integration works:",
                  sub_header: "",
                  video: "https://www.youtube.com/embed/HD5xmlDrb9Q?si=sJNRWSta5tOyv57f" 
                }
              ]
            },
            {
              id: "technical_requirements",
              title: "Technical Requirements",
              sub_sections: [
                {
                  header: "For this integration to be successful, you will require:",
                  sub_header: "",
                  content: [
                  "<b>Paperflite Chrome Extension:</b> Make sure to have the latest chrome extension downloaded and stay logged in to your Paperflite account.",
                  "<b>Outreach Account:</b> Make sure to have an active Outreach account logged in.",
                ]
                }, 
                {
                  header: "Necessary permissions",
                  sub_header: "By activating this integration, Paperflite will  have access to your Outreach account. This means Paperflite will have access to:",
                  content: [
                    "The basic scope required for OAuth.",
                    "Read your basic profile information.",
                    "All CRM data"
                  ]
                }
              ]
            }
          ],
          support_articles: {
            title: "Support Articles:",
            content: [
              {
                title: "Paperflite X Outreach",
                url: "https://support.paperflite.com/en/articles/10398107-integrating-outreach-with-paperflite"
              },
            ]
          }
      },    
     pardot:
      {
        type: "Pardot",
        title: "Welcome to Paperflite’s integration with Pardot! Enhance your marketing and sales prowess.",
        sections: [
          {
            id: "about",
            title: "About",
            sub_sections : [
              {
                header: "What you get out of this integration:",
                sub_header: "",
                content: [
                  'Automatically capture leads gained through gated shares from Paperflite directly into Pardot.',
                  'Seamlessly sync lead and engagement data including between Paperflite and Pardot, eliminating manual data entry.',
                  'Enjoy automated workflows that save time and effort, allowing your team to focus on nurturing leads and closing deals.',
                  'Monitor prospect engagement activities in real-time within Pardot, enabling you to tailor your outreach strategies effectively.',
                  'Gain deeper insights into prospect behavior and campaign performance by accessing detailed analytics directly within Paperflite’s Conversations empowering data-driven decision-making.'
                ]
              }
            ]
          },
          {
            id: "configuration",
            title: "Configuration",
            sub_sections: [
              {
                header: "Get started: Learn how to integrate",
                sub_header: "",
                content: [
                  "Ensure you're logged in to the Pardot account you wish to integrate.",
                  "Authenticate the Pardot account: <br/> &nbsp; - Enter your Pardot credentials <br/> &nbsp;  - Enter your Business unit ID",
                  "Make sure the create lead toggle is turned on and save the configuration settings.",
                  "Your integration is now ready to go!"
                ],
              }
            ]
          },
          {
            id: "demo_video",
            title: "Demo Video",
            sub_sections: [
              {
                header: "Watch this video to see how the integration works:",
                sub_header: "",
                video: "https://www.youtube.com/embed/ysWIvFnETFU?si=FBcWE4J_OrPl9Zdc"
              }
            ]
          },
          {
            id: "technical_requirements",
            title: "Technical Requirements",
            sub_sections: [
              {
                header: "For this integration to be successful, you will require:",
                sub_header: "",
                content: [
                "<b>Pardot Account:</b> Make sure to have an active Pardot account logged in.",
              ]
              }, 
            ]
          }
        ],
        support_articles: {
          title: "Support Articles:",
          content: [
            {
              title: "Paperflite X Pardot",
              url: "https://support.paperflite.com/en/articles/10398128-integrating-pardot-with-paperflite"
            },
          ]
        },
    },
    zoho:
    {
      type: "Zoho",
      title: "Welcome to Paperflite’s integration with Zoho! Elevate your sales game with seamless content sharing and detailed analytics.",
      sections: [
        {
          id: "about",
          title: "About",
          sub_sections: [
            {
              header: "What you get out of this integration:",
              sub_header: "",
              content: [
                'Share all your sales and marketing content via Zoho using our plugin from within contacts, leads, templates.',
                'Sync all your Zoho leads and contacts with Paperflite within minutes.', 
                'Automatically capture leads gained through gated shares from Paperflite directly into Zoho.',
                'Learn what your prospects have been viewing, downloading and re-sharing, so you can tailor your follow-ups accordingly',
                'Sync events to track preferred prospect engagement events like views, downloads, shares for tailored follow-ups',
                'Capture every interaction, from page-level views to time spent on videos',
                'Gain insights into share history associated with your contacts and leads along with analytics.',
              ]
            }
          ]
        },
        {
          id: "configuration",
          title: "Configuration",
          sub_sections: [
            {
              header: "Get started: Learn how to integrate",
              sub_header: "",
              content: [
                "Ensure you're logged in to the Zoho account you wish to integrate.",
                "Authenticate the Zoho account.",
                'Make sure you have downloaded and logged into the <a href="https://support.paperflite.com/en/articles/10398099-chrome-extension" target="_blank">Chrome extension.</a>',
                "Configure settings according to your preferences.",
                "Your integration is now ready to go!",
              ],
              note: "<b> Note: </b> The integration with Zoho is an admin level integration. This means only admins would have the access to activate the integration and make configuration changes at an account level."
            }
          ]
        },
        {
          id: "demo_video",
          title: "Demo Video",
          sub_sections: [
            {
              header: "Watch this video to see how the integration works:",
              sub_header: "",
              video: "https://www.youtube.com/embed/PAnv5PzoL-k?si=2u75IaR5yGMDxrZN"
            }
          ]
        },
        {
          id: "technical_requirements",
          title: "Technical Requirements",
          sub_sections: [
            {
              header: "For this integration to be successful, you will require:",
              sub_header: "",
              content: [
              "<b>Paperflite Chrome Extension:</b> Make sure to have the latest chrome extension downloaded and stay logged in to your Paperflite account.",
              "<b>Zoho Account: </b> Make sure to have an active Zoho account logged in.",
            ]
            }, 
            {
              header: "Necessary permissions",
              sub_header: "By activating this integration, Paperflite will  have access to your Zoho account. This means Paperflite will have access to:",
              content: [
                "The basic scope required for OAuth.",
                "Read your basic profile informations.",
                "Manage profiles",
                "Manage organization data",
                "Manage user data",
                "Full CRM data",
              ]
            }
          ]
        }
      ],
      support_articles: {
        title: "Support Articles:",
        content: [
          {
            title: "Paperflite X Zoho",
            url: "https://support.paperflite.com/en/articles/10398120-zoho-crm-integration",
          },
        ]
      }
    },
    ms_dynamics: 
    {
      type: "MsDynamics",
      title: "Welcome to Paperflite’s integration with MS Dynamics! Maximize sales reps' efficiency and increase deal win rates.",
      sections: [
        {
          id: "about",
          title: "About",
          sub_sections : [
            {
              header: "What you get out of this integration:",
              sub_header: "",
              content: [
                "Sync all your MS Dynamics contacts and leads with Paperflite within minutes.",
                "Learn what your leads and contacts have been viewing, downloading and re-sharing, so you can tailor your follow-ups accordingly.",
                "Sync events to track preferred prospect engagement events like views, downloads, shares for tailored follow-ups.",
                "Automatically capture leads gained through gated shares from Paperflite directly into MS Dynamics.",
                "Capture every interaction, from page-level views to time spent on videos",
                "Gain insights into share history associated with your contacts and leads along with analytics.",
                "Effortlessly map deals from MS Dynamics to shares made to associated contacts in Paperflite",
                "Eliminate the need to switch platforms with access to the Paperflite native app within MS Dynamics.",
                "Tag content in Paperflite using fields from MS Dynamics, enabling personalized content recommendations at an opportunity level using AI-powered algorithms.",
              ]
            }
          ]
        },
        {
          id: "configuration",
          title: "Configuration",
          sub_sections: [
            {
              header: "Get started: Learn how to integrate",
              sub_header: "",
              content: [
                "Ensure you're logged in to the MS Dynamics account you wish to integrate.",
                "Authenticate the MS Dynamics account: <br/> &nbsp; - Choose the MS Dynamics account you want to integrate. <br/> &nbsp; - Enter your domain instance url from MS Dynamics in Paperflite. <br/> &nbsp; - Review permissions and connect the app.",
                'Make sure you have downloaded and logged into the <a href="https://support.paperflite.com/en/articles/10398099-chrome-extension" target="_blank">Chrome extension.</a>',
                "Configure settings according to your preferences.",
                "Your integration is now ready to go!",
              ],
              note: "<b> Note: </b> The integration with MS Dynamics is an admin level integration. This means only admins would have the access to first activate, and make changes at an account level. Once an admin has configured the integration for the account, the rest of the users in the company will have the integration activated and be able to override the configuration settings for themselves. .",
            }
          ]
        },
        {
          id: "demo_video",
          title: "Demo Video",
          sub_sections: [
            {
              header: "Watch this video to see how the integration works:",
              sub_header: "",
              video: "https://www.youtube.com/embed/6wOax0EciAQ?si=YHkmHWrtLwABjVq1"
            }
          ],
        },
        {
          id: "technical_requirements",
          title: "Technical Requirements",
          sub_sections: [
            {
              header: "For this integration to be successful, you will require:",
              sub_header: "",
              content: [
              "<b>Paperflite Chrome Extension:</b>  Make sure to have the latest chrome extension downloaded and stay logged in to your Paperflite account.",
              "<b>MS Dynamics Account: </b> Make sure to have an active MS Dynamics account logged in.",
            ]
            },
            {
              header: "Necessary permissions",
              sub_header: "By activating this integration, Paperflite will  have access to your MS Dynamics account. This means Paperflite will have access to:",
              content: [
                "<b>Manage and View your CRM Data: </b> Access to properties and other details about deals, contacts and companies.",
                "<b>Basic OAuth functionality: </b> The basic scope required for OAuth.",
              ]
            }
          ]
        }
      ],
      support_articles: {
        title: "Support Articles:",
        content: [
          {
            title: "Paperflite X MS Dynamics",
            url: "https://support.paperflite.com/en/articles/10398132-microsoft-dynamics-integration"
          },
          {
            title: "Accessing Paperflite within MS Dynamics",
            url: "https://support.paperflite.com/en/articles/10398093-accessing-paperflite-within-ms-dynamics",
          },
        ]
      }
    },
    linkedIn: 
    {
      type: "LinkedIn",
      title: "Welcome to Paperflite's integration with LinkedIn! Share content and see how it performs on Linkedin, all from your Paperflite workspace",
      sections: [
        {
          id: "about",
          title: "About",
          sub_sections : [
            { 
              header: "What you get out of this integration:",
              content: [
                "<b>Instant Content Sharing:</b> Share assets directly to LinkedIn with customizable descriptions and images right from Paperflite",
                `<b>AI-Powered Content Enhancement: </b> Use 'SEEK' to rephrase and optimize your post descriptions with different tones`,
                "<b>Rich Media Support:</b> Share your content with images or videos",
                "<b>Advanced Analytics:</b> Track comprehensive engagement metrics for your shared content within Paperflite"
            ]
            }
          ]
        },
        {
          id: "configuration",
          title: "Configuration",
          sub_sections: [
            {
              header: "Get started: Learn how to integrate",
              content: [
                "Authenticate your LinkedIn account with Paperflite",
                "Ensure you have the appropriate access level (administrator, content publisher, or edit access)",
                "Start sharing content directly from your asset library"
              ]
            }
          ]
        },
        {
          id: "demo_video",
          title: "Demo Video",
          sub_sections: [
            {
              header: "Watch this video to see how the integration works:",
              video: "https://www.youtube.com/embed/r0alxDD8a7M?si=SUlEYke3oRxenzhv"
            }
          ]
        },
        {
          id: "technical_requirements",
          title: "Technical Requirements",
          sub_sections: [
            {
              header: "For this integration to be successful, you will require:",
              content: [
                "Active LinkedIn account with posting permissions",
                "Appropriate Paperflite access level",
                "Supported image and video formats (specific formats to be listed)"
              ]
            }, 
            {
              header: "Necessary permissions",
              sub_header: "By activating this integration, Paperflite will have access to:",
              content: [
                "View content and profile information",
                "Access analytics data for shared posts",
                "Track engagement metrics for your content",
                
          ]}
          ]
        }
      ],
    },
  }
}